import React from 'react';
import PropTypes from 'prop-types';
import PostsSmallStyles from './PostsSmall.styled';
import PostSmall from '../Shared/PostSmall';
import { useInView } from 'react-intersection-observer';

const PostsSmall = ({ posts = [], isAnimated = true }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.35 });
  return (
    <PostsSmallStyles
      className={`block-posts_small ${isAnimated ? 'isAnimated' : ''} ${
        inView ? 'active' : ''
      }`}
      ref={ref}
    >
      <div className='inner'>
        {posts.map((props, i) => (
          <PostSmall
            key={i}
            style={{ transitionDelay: `${i * 0.2}s` }}
            {...props}
          />
        ))}
      </div>
    </PostsSmallStyles>
  );
};

PostsSmall.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      thumbnail: PropTypes.string,
      title: PropTypes.string,
      category: PropTypes.string,
      slug: PropTypes.string,
      mediaType: PropTypes.string,
    })
  ),
};

export default PostsSmall;
